import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import '../App.css';
import axios from 'axios';

// Spinner CSS
const spinnerStyle = {
  display: 'none',
  border: '16px solid #f3f3f3',
  borderTop: '16px solid #3498db',
  borderRadius: '50%',
  width: '120px',
  height: '120px',
  animation: 'spin 2s linear infinite',
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const dropzoneStyle = {
  border: '2px dashed #8f8e8e',
  borderRadius: '4px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
  color: '#8f8e8e',
  marginTop: '50px',
};

const UploadDocuments = () => {
  const [uploadStatus, setUploadStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: async (acceptedFiles) => {
      setUploadStatus('');
      setLoading(true);
      for (const file of acceptedFiles) {
        try {
          // Request a pre-signed URL from your backend
          const response = await axios.post('https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/upload', {
            filename: file.name
          });

            const data = response.data;
            const presignedUrl = data['presignedUrl'];
            // console.log('Presigned URL:', presignedUrl);

            // Upload the file directly to S3 using the pre-signed URL
            await axios.put(presignedUrl, file, {
              headers: {
                'Content-Type': file.type,
              }
            });
            setUploadStatus('File uploaded successfully 🗂️.');

        const invokeLambda = async () => {
          try {
              const response = await fetch('https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/async_embed', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ 
                    'function_name': 'embedDocs',
                    'filename': file.name 
                  })
              });
      
              if (!response.ok) {
                  throw new Error(`Error: ${response.statusText}`);
              }
      
              const data = await response.json();
              console.log('Lambda invoked asynchronously:', data);
          } catch (error) {
              console.error('Error invoking Lambda function:', error);
          }
      };

      invokeLambda();

        } catch (error) {
          console.error('Upload failed:', error);
          setUploadStatus('Upload failed');
        } finally {
          setLoading(false);
        }

      }
    }
  });

  return (
    <div>
      <div className="title-section">
        <h2 className="title-text">Upload Documents</h2>
        <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/Interview_Scripter.png" alt="RFC Problem Analysis" className="title-icon2" />
      </div>
      <div {...getRootProps()} style={dropzoneStyle}>
        <input {...getInputProps()} />
        <p>Drag and drop some files here, or click to select files</p>
      </div>
      <p className="placeholder-text-interview">Uploading long files can take a long time, please do not leave or close the page.</p>
      {loading && <div className="spinner"></div>}
      {uploadStatus && <p style={{ textAlign: 'left', marginTop: '20px', fontSize: '20px'}}>{uploadStatus}</p>}
    </div>
  );
}

export default UploadDocuments;